import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';

@Component({
  selector: 'drag-drop',
  templateUrl:
    'console/app-js/shared/components/drag-drop/drag-drop.component.html'
})
export class DragDropComponent implements OnInit {
  @Output() select = new EventEmitter<SelectEvent>();
  @Input() text: any;
  @Input() disabled: boolean;
  @Input() uploadRestrictions: FileRestrictions = {
    allowedExtensions: []
  };

  protected pdfTemplate;
  ngOnInit() {
    this.pdfTemplate = '';
    if (this.text.includes('Product')) {
      this.pdfTemplate = '../console/templates/bulk-add-products-template.xlsx';
    } else if (this.text.includes('Asset')) {
      this.pdfTemplate = '../console/templates/bulk-add-assets-template.xlsx';
    } else if (this.text.includes('Status')) {
      this.pdfTemplate = '../console/templates/bulk-update-asset-status.xlsx';
    } else if (this.text.includes('Part')) {
      this.pdfTemplate = false;
    } else if (this.text.includes('Another')) {
      this.pdfTemplate = false;
    } else if (this.text.includes('Warranty')) {
      this.pdfTemplate =
        '../console/templates/warranty-duration-bulk-template.xlsx';
    }
  }
  constructor() {
    //
  }

  selectEventHandler(event: SelectEvent): void {
    this.select.emit(event);
  }
}
